
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    {
      /* KEYWORDS: comparison, blockchain, distribution, proof-of-stake, proof-of-work */
    }
    <h1>{`Comparison with other blockchain networks`}</h1>
    <p>{`Historically, Peercoin originated as a fork of Bitcoin with added functionalities and protocol tuning to support Proof-of-Stake.  Peercoin was invented as a response to increasing concerns about the efficiency of the Bitcoin PoW consensus model, as well as its increasing centralization and conflict of interests between miners.  Peercoin keeps much of the core code from Bitcoin, though it fundamentally changes the consensus model as well as introducing a number of new protocol paradigms and economics, including breaking the deflationary model of Bitcoin in favor of a sane and accountable level of inflation.`}</p>
    <p>{`The fee market is also a subject where Peercoin and Bitcoin differ. By moving to a fixed-fee model, the entire perspective of the blocksize limit and blockchain bandwidth is flipped upside down. While Bitcoin has a fee market by which miners (PoW block creators) are paid to process transactions so that the total supply can remain deflationary, in Peercoin the minters (PoS block creators) are always rewarded for their participation with a proportional amount of inflation.  As such, Peercoin is free to burn the transaction fees such that the virtual-revenue of a transaction is shared by the entire network. By looking at the bandwidth problem as a community rather than individual nodes, we adopt a fixed fee level of 0.01 PPC/KB that allows for long-term prediction of transaction fee costs. The entirety of Peercoin's blockchain is on the order of 1 GB, so blocksize limitations have never been tested. However, there is vast consensus in the community that if the blocksize approached the current limit, the limit would be lifted.`}</p>
    <table>
      <thead>
        <tr>
          <th>Features</th>
          <th>Bitcoin</th>
          <th>Peercoin</th>
          <th>Ethereum</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Main use-case:</td>
          <td>p2p financial transactions / store of value</td>
          <td>p2p financial transactions / store of value</td>
          <td>Turing complete smart contracts</td>
        </tr>
        <tr>
          <td>Consensus algorithm:</td>
          <td>PoW</td>
          <td>PoS</td>
          <td>PoW</td>
        </tr>
        <tr>
          <td>Active since:</td>
          <td>2009</td>
          <td>2012</td>
          <td>2015</td>
        </tr>
        <tr>
          <td>Distribution method:</td>
          <td>PoW block reward</td>
          <td>PoW block reward / PoS block reward</td>
          <td>Initial Coin Offering / PoW block reward</td>
        </tr>
        <tr>
          <td>Distribution:</td>
          <td>Limited, until 21M tokens exist in the system.</td>
          <td>Unlimited.</td>
          <td>Unlimited.</td>
        </tr>
        <tr>
          <td>Transaction fee:</td>
          <td>Fee market (~100 satoshis/byte, ~$20/txn)</td>
          <td>Static (0.01 PPC/kb, ~$0.005/txn)</td>
          <td>Fee market (~100 Gwei/byte, ~$20/txn)</td>
        </tr>
        <tr>
          <td>Estimated transaction bandwidth:</td>
          <td>7 tx/sec</td>
          <td>8 tx/sec</td>
          <td>25 tx/sec</td>
        </tr>
        <tr>
          <td>Block time:</td>
          <td>10 minutes</td>
          <td>8.57 minutes</td>
          <td>12 seconds</td>
        </tr>
        <tr>
          <td>Block size:</td>
          <td>1MB</td>
          <td>1MB</td>
          <td>Dynamic</td>
        </tr>
        <tr>
          <td>Extra transaction data size limit:</td>
          <td>80 Byte<br />(OP_RETURN)</td>
          <td>256 Byte<br />(OP_RETURN)</td>
          <td>Dynamic<br />(5 gas / byte)</td>
        </tr>
        <tr>
          <td>Topology:</td>
          <td>Public blockchain</td>
          <td>Public blockchain</td>
          <td>Public blockchain</td>
        </tr>
      </tbody>
    </table>
Table 1. Comparison of Crypto currency attributes
(prices of transactions at the time of writing)
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;